import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { View } from "ui/atoms/view";
import { Pressable, Text } from "react-native";
import { AssessmentHistoryTemplate } from "app/features/reporting/templates/AssessmentHistoryTemplate";
import { usePathname, Link } from "expo-router";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { useFormsWithOffline } from "app/features/offline/hooks/useFormsWithOffline";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { useState, useEffect } from "react";
import { Button, ButtonText } from "ui/gluestack/button";

export function MedicalNotesScreen() {
  const pathname = usePathname();
  const { resident } = useResidentContext();

  const filter = { tag: FormEnums.MEDICAL_NOTES };
  const { data: forms, isFetching } = useFormsWithOffline(filter);

  const [selectedFormId, setSelectedFormId] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    if (forms?.length && selectedFormId === undefined) {
      setSelectedFormId(forms[0].id);
    }
  }, [forms, selectedFormId]);

  if (isFetching) {
    return <LoadingSpinner />;
  }

  return (
    <View className="resident-container">
      <Text className="text-lg font-semibold mb-4">Medical Notes</Text>
      <View className="flex flex-col sm:flex-row gap-4">
        <View className="sm:w-56 flex flex-col gap-4">
          <PermissionCheck permission={PermissionsEnums.VIEW_FORM}>
            <View className="bg-secondary-0 rounded-lg px-4 py-5">
              <View className="gap-y-2">
                {forms?.map((form) => (
                  <Pressable
                    key={form.id}
                    onPress={() => setSelectedFormId(form.id)}
                  >
                    <View
                      className={`p-2 rounded-lg flex ${
                        selectedFormId === form.id
                          ? "bg-primary-0 font-medium"
                          : "font-normal"
                      }`}
                    >
                      <Text>{form.name}</Text>
                    </View>
                  </Pressable>
                ))}
              </View>
            </View>
          </PermissionCheck>

          {selectedFormId && (
            <PermissionCheck permission={PermissionsEnums.FILL_FORM}>
              <Link href={`${pathname}/${selectedFormId}`} asChild>
                <Button variant="outline" action="primary" size="lg">
                  <ButtonText>New Entry</ButtonText>
                </Button>
              </Link>
            </PermissionCheck>
          )}
        </View>

        <View className="flex flex-1 flex-col">
          <PermissionCheck permission={PermissionsEnums.VIEW_FORM_ENTRIES}>
            <AssessmentHistoryTemplate
              tag={FormEnums.MEDICAL_NOTES}
              residentId={resident?.id}
              formId={selectedFormId}
            />
          </PermissionCheck>
        </View>
      </View>
    </View>
  );
}
